import { render, staticRenderFns } from "./HitsAmount.vue?vue&type=template&id=4e3ee7b0&"
import script from "./HitsAmount.vue?vue&type=script&lang=ts&"
export * from "./HitsAmount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports